import React, {useState} from "react";
import Navigate from "../../components/Navigate";
import {isFormComplete, notifyUser} from "../../util/util";
import {Spin} from "antd";
import { useNavigate } from 'react-router-dom';
import { useLogin } from "../../hooks/api";
import secureLocalStorage from 'react-secure-storage';

export const Login = () => {
    const navigate = useNavigate();
    const [form, setForm] = useState({ username: '', password: '' })
    const [passwordType, setPasswordType] = useState('password')
    
    const loginMutation = useLogin();
    
    const togglePasswordType = () => {
       if(passwordType === 'password'){
         setPasswordType('text')
       }else{
         setPasswordType('password')
       }
    }

    const changeHandler = (e) => setForm({...form, [e.target.name]: e.target.value})

    const submitLogin = () => {
      if (isFormComplete(form)){
          
          loginMutation.mutate(form, {
              onSuccess: (data) => {
                  
                  // Check if login was successful and token exists (handle both token field names)
                  if (data?.success && (data?.data?.accessToken || data?.data?.authToken)) {
                      const mustChangePassword = data?.data?.mustChangePassword === true;
                      const requiresAccountSetup = mustChangePassword || data?.data?.setupComplete === false;

                      // Keep the flag until both the password and PIN setup steps finish.
                      secureLocalStorage.setItem('mustChangePassword', requiresAccountSetup);
                      secureLocalStorage.setItem('loginUsername', form.username);
                      
                      // Small delay to ensure token is stored before navigation
                      setTimeout(() => {
                          navigate(requiresAccountSetup ? '/onboard/create-password' : '/dashboard', {
                              state: requiresAccountSetup ? {email: form.username} : undefined
                          });
                      }, 100);
                  } else {
                      notifyUser('error', data?.message || 'Login failed - invalid credentials', 'Error');
                  }
              },
              onError: (error) => {
              }
          });
      } else {
          notifyUser('error', 'All fields are required!', 'Validation Error')
      }
    }

    return (
        <div className='mx-auto mobile-full-width shadow bg-white p-5 rounded login-width'>
            <div align='center'>
                <p className='lead fw-bold'>Login</p>
                <small className='text-center'>Sign in into your account</small>

                <div className="mt-4 w-75 mx-auto mobile-full-width">
                    <Spin spinning={loginMutation.isPending}>
                        <omk-text-field  label="Email" value={form.username} type='email' class='mb-4' onInput={changeHandler} name='username'/>
                        <omk-text-field  label="Password" value={form.password} type={passwordType} class='mb-4' onInput={changeHandler} name='password'>
                            <omk-icon slot="trailing-icon" onClick={togglePasswordType} style={{ cursor: 'pointer'}}><i className="bi bi-eye-slash"/></omk-icon>
                        </omk-text-field>
                        <Navigate path='/forgot-password/employee-number'>
                            <p className="text-center omk-text-small fw-bold">Forgot Password?</p>
                        </Navigate>
                        <p className="text-center omk-text-small text-black-50"><i className="bi bi-shield-lock"/> Your information is confidential and secure</p>

                        <button className="btn btn-primary mb-4 w-50 mobile-full-width" onClick={submitLogin}>Login</button>
                        {/*<omk-button button-size="small" class='mb-5'>Login</omk-button>*/}
                    </Spin>
                    <Navigate path='/onboard/employee-number'>
                        <p className="text-center omk-text-small fw-bold">Have no account? Onboard here</p>
                    </Navigate>
                </div>
            </div>
        </div>
    )
}
